import { useState } from 'react';
import { api } from '@/lib/api';
export interface LmsSourceQuestionSnapshot {
  id: string;
  body: string;
  source_number: string;
  start_page: number;
  end_page?: number;
  source_regions: unknown[];
}
export function LmsSourceQuestion({
  question,
  assignmentId,
  request = api,
}: {
  question: LmsSourceQuestionSnapshot;
  assignmentId: string;
  request?: typeof api;
}) {
  const [images, setImages] = useState<Record<number, string>>({}),
    [busy, setBusy] = useState<number | null>(null),
    [error, setError] = useState('');
  return (
    <section className="rounded-2xl border border-hairline p-4 space-y-3">
      <p className="font-bold">
        Question {question.source_number} · source{' '}
        {question.end_page && question.end_page > question.start_page
          ? `pages ${question.start_page}–${question.end_page}`
          : `page ${question.start_page}`}
      </p>
      <p className="whitespace-pre-wrap">{question.body}</p>
      {(question.source_regions ?? []).map((_, i) => (
        <div key={i}>
          {images[i] ? (
            <img
              className="max-w-full rounded-xl"
              alt={`Source excerpt for question ${question.source_number}, figure ${i + 1}`}
              src={images[i]}
            />
          ) : (
            <button
              type="button"
              className="btn-pill-secondary"
              disabled={busy !== null}
              onClick={async () => {
                try {
                  setBusy(i);
                  setError('');
                  const v = await request<{ mime: string; data_base64: string }>(
                    `/study/learning-plans/tasks/${encodeURIComponent(assignmentId)}/questions/${encodeURIComponent(question.id)}/figures/${i}`,
                  );
                  setImages((old) => ({ ...old, [i]: `data:${v.mime};base64,${v.data_base64}` }));
                } catch {
                  setError(
                    'This source figure is unavailable. Retry or ask your teacher before answering.',
                  );
                } finally {
                  setBusy(null);
                }
              }}
            >
              {busy === i ? 'Loading figure…' : `Open source figure ${i + 1}`}
            </button>
          )}
        </div>
      ))}
      {error && (
        <p className="field-error" role="alert">
          {error}
        </p>
      )}
    </section>
  );
}
